import { CaseReducer, PayloadAction } from '@reduxjs/toolkit';

// MODEL
import {
  OnBoardingState,
  AccountStatus,
  LovedOneType,
  B3LookupResult,
  BlockedReason,
  B3ClientSnapshot,
  LinkpassPrefill
} from 'model';

// ----------------------------- LOADING -----------------------------------

export const changeLoading: CaseReducer<OnBoardingState, PayloadAction<boolean>> = (state, action) => {
  state.loading = action.payload;
};

// ----------------------------- LOVED ONE -----------------------------------

export const setLovedOne: CaseReducer<OnBoardingState, PayloadAction<LovedOneType | ''>> = (state, action) => {
  state.lovedOne = action.payload;
};

// ----------------------------- NRIC -----------------------------------

export const setNric: CaseReducer<OnBoardingState, PayloadAction<string>> = (state, action) => {
  state.nric = action.payload;
};

// ----------------------------- ACCOUNT STATUS -----------------------------------

export const setAccountStatus: CaseReducer<OnBoardingState, PayloadAction<AccountStatus | undefined>> = (
  state,
  action
) => {
  state.accountStatus = action.payload;
};

// ----------------------------- SUGGESTED ROLE -----------------------------------

export const setSuggestedRole: CaseReducer<OnBoardingState, PayloadAction<'SELF' | null | undefined>> = (
  state,
  action
) => {
  state.suggestedRole = action.payload;
};

// ----------------------------- VERIFIED -----------------------------------

export const setVerified: CaseReducer<OnBoardingState, PayloadAction<boolean>> = (state, action) => {
  state.isVerified = action.payload;
};

// ----------------------------- SESSION ID -----------------------------------

export const setSessionId: CaseReducer<OnBoardingState, PayloadAction<string | undefined>> = (state, action) => {
  state.sessionId = action.payload;
};

// ----------------------------- B3 LOOKUP RESULT -----------------------------------

export const setB3LookupResult: CaseReducer<OnBoardingState, PayloadAction<B3LookupResult | undefined>> = (
  state,
  action
) => {
  state.b3LookupResult = action.payload;
};

// ----------------------------- LOOKUP BLOCKED REASON -----------------------------------

export const setLookupBlocked: CaseReducer<OnBoardingState, PayloadAction<BlockedReason | null | undefined>> = (
  state,
  action
) => {
  state.lookupBlocked = action.payload;
};

// ----------------------------- COMPLETED ONBOARD -----------------------------------

export const setCompletedOnboard: CaseReducer<OnBoardingState, PayloadAction<boolean>> = (state, action) => {
  state.completedOnboard = action.payload;
};

// ----------------------------- B3 CLIENT SNAPSHOT -----------------------------------

export const setB3Snapshot: CaseReducer<OnBoardingState, PayloadAction<B3ClientSnapshot | undefined>> = (
  state,
  action
) => {
  state.b3Snapshot = action.payload;
};

// ----------------------------- LINKPASS PREFILL -----------------------------------

export const setLinkpassPrefill: CaseReducer<OnBoardingState, PayloadAction<LinkpassPrefill | undefined>> = (
  state,
  action
) => {
  state.linkpassPrefill = action.payload;
};
